'use client'

import { parseApiAsset } from '@morpho-org/dapp-core'

import MerklRewardsHoverCard from '@/components/common/RewardsHoverCard/MerklRewardsHoverCard'
import { normalizeVaultApyRewards } from '@/helpers/rewards'
import { useVaultV1Apy } from '@/hooks/useVaultV1Apy'

import type { VaultApyCardData } from '../VaultApyCard.mapper'

export interface RateCardProps {
  vault: VaultApyCardData
}

/**
 * RateCard component to display all the rates for the vault
 */
const RateCard = ({ vault }: RateCardProps) => {
  const asset = parseApiAsset(vault.asset)

  const { apy, netApy, performanceFee, points, rewards } = useVaultV1Apy({
    vaultV1: {
      address: vault.address,
      asset: vault.asset,
      state: vault.state,
      rewards: normalizeVaultApyRewards(vault.rewards)
    }
  })

  return (
    <div className="bg-muted border-border py-md px-md max-h-[332px] w-[275px] overflow-y-auto rounded-[20px] border-[0.5px] max-lg:max-h-[345px] max-lg:w-full max-lg:rounded-none max-lg:border-0 max-lg:bg-transparent max-lg:p-0">
      <MerklRewardsHoverCard
        rewards={rewards}
        apy={apy}
        netApy={netApy}
        performanceFee={performanceFee}
        variant="vault"
        points={points}
        asset={asset}
        hideNetApyHeader
      />
    </div>
  )
}

export default RateCard
